// export default {
//     'errno': 0,
//     'errstr': 'OK',
//     'data': {
//         'red_envelope_list': [
//             {
//                 'type': 'worldcup',
//                 'heading': 284,
//                 'pitch': 0,
//                 'icon': 'https://cjh-amis.cdn.bcebos.com/2022-12/1669973299887/i-packet.png',
//                 'rank': 0,
//                 'message': '世界杯加油',
//                 'back_image': 'https://mapclient.cdn.bcebos.com/pano/activity/worldcup/packet-btn.png'
//             }
//         ]
//     }
// };

export default {
    'errno': 0,
    'errstr': 'OK',
    'data': {
        'bubbles_list': [
            {
                'type': 1,
                'heading': 1,
                'pitch': 0,
                'message': '世界杯加油',
                'rank': 0,
                'icon_img': 'https://cjh-amis.cdn.bcebos.com/2022-12/1669973299887/i-packet.png',
                // eslint-disable-next-line max-len
                'jump_url': 'baidumap%3A%2F%2Fmap%2Ffloatweb%3Faction%3Dopen%26popRoot%3Dno%26url%3Dhttp%3A%2F%2Fdev-quda.bcc-szth.baidu.com%3A8086%2Fstatic%2Fpano-hongbao%2Fpano-hongbao.html%3Ftype%3D1%26pid%3D0800720000141122162021059UZ%26source%3Dfeed',
                'toast_content': '左右晃一晃'
            }
        ]
    }
};